import { usePcRawMaterialRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetPcRawMaterialCommonInfoQuery } from "../../features/api/pcRawMaterialApi";

export { usePcRawMaterialRoutes };

interface IPcRawMaterialsProps {
  isEstimated: boolean;
}

const PcRawMaterial = ({ isEstimated }: IPcRawMaterialsProps) => {
  let title = isEstimated ? "خرید و مصرف مواد اولیه (برآوردی)" :  "خرید و مصرف مواد اولیه";

  return GetDefaultIndex({
    title: title,
    query: useGetPcRawMaterialCommonInfoQuery,
    queryArgs: isEstimated,
  })();
};

export default PcRawMaterial;
